export default "__VITE_ASSET__DKYWf5aC__"